import { Component, OnInit, NgModule } from '@angular/core';
import { HttpClient, HttpRequest } from '@angular/common/http';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import * as _moment from 'moment';
import { DomSanitizer, SafeResourceUrl, SafeUrl } from '@angular/platform-browser';
import {AppComponent} from '../../app.component';
import { Location } from '@angular/common';
import { filter } from 'rxjs/operators';

@Component({
    selector: 'app-module',
    templateUrl: './module.component.html',
    styleUrls: ['./module.component.css'],
    standalone: false
})
export class ModuleComponent implements OnInit {
  url: string;
  id: any;
  ModuleData: any;
  lastRoute: string = '/dashboard';
  history: string[] = [];


  constructor(private router: Router, private http: HttpClient, private sanitization: DomSanitizer, private location: Location,) {this.url = AppComponent.baseURL; 
      this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.history.push(event.urlAfterRedirects);
      });
  }

  ngOnInit() {   
   this.factSheetData();
  }
  goHome() {
    this.router.navigate(
      ['dashboard'],
     );
  }
    goBack(): void {
    this.history.pop();

    const previousUrl = this.history.pop();

    if (previousUrl) {
      this.router.navigateByUrl(previousUrl);
    } else {
      this.router.navigate(['/dashboard']);
    }
  }
  factSheetData() {
    this.id = 100;
    // this.http.get(this.url + 'Dashboard/GetDashboardModule?GenID=' + this.id)
    // this.http.get(this.url + 'filter/GetMasterDesign?GenID=202024000')
    // .subscribe( (data) =>   {
    //     if (data == null) {
    //       this.ModuleData = null;
    //     } else {
    //       alert(data);
    //       console.log(JSON.parse(data.toString()));
    //       console.log(data.toString());
    //       console.log(data);
    //       this.ModuleData = JSON.parse(data.toString());
    //     }
    //    }
    // );
  }
}
